import { Context } from '@nuxt/types'
import { siteBroadcasterUrl } from '~/assets/ts/utils/urls'

export default function (context: Context) {
  const id = context.$users.user?.myChurchBroadcasterID
  if (id) {
    context.$redirectTo(siteBroadcasterUrl(id))
  }
}
